import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../../state'

@ngCore.Component({
  imports: [
    ds.input.pillButton.Component,
    ds.input.radio.options.Component,
    ds.input.radio.value.Directive,
    ds.input.text.Component,
  ],
  selector: 'atn-scenario-general-tab',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  public get scenarioVisibilityEnum(): typeof ents.core.admin.Scenario.Visibility {
    return ents.core.admin.Scenario.Visibility
  }

  /** @see {@link state.routeBound.scenarios.Feature} */
  public readonly scenariosFeature = ngCore.inject(
    state.routeBound.scenarios.Feature,
  )

  /** Scenario draft currently edited by the dialog. */
  public readonly editingScenarioSg =
    this.scenariosFeature.selectors.editingScenarioDraft.asSignal

  public scenarioVisibilityChangeHandler(
    visibility: ents.core.admin.Scenario.Visibility,
  ): void {
    this.scenariosFeature.actions.editDraft
      .from('ScenarioEditDialog.Tabs.General.Form.VisibilityInput.Changed')
      .dispatch({ visibility })
  }

  public editScenario = <K extends keyof ents.core.admin.Scenario.Input>(
    key: K,
    value: ents.core.admin.Scenario.Input[K],
  ) => {
    this.scenariosFeature.actions.editDraft
      .from(`ScenarioEditDialog.Tabs.General.Form.${String(key)}Input.Changed`)
      .dispatch({ [key]: value })
  }
}
